module.exports = __webpack_public_path__ + "ug.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ug.svg
// module id = 1119
// module chunks = 0